/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectTimeUpdateCreateProjectTimeUpdatePost } from '../fn/project-time-updates/api-project-time-update-create-project-time-update-post';
import { ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Params } from '../fn/project-time-updates/api-project-time-update-create-project-time-update-post';
import { apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain } from '../fn/project-time-updates/api-project-time-update-create-project-time-update-post-plain';
import { ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Params } from '../fn/project-time-updates/api-project-time-update-create-project-time-update-post-plain';
import { apiProjectTimeUpdateDeleteProjectTimeUpdateDelete } from '../fn/project-time-updates/api-project-time-update-delete-project-time-update-delete';
import { ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Params } from '../fn/project-time-updates/api-project-time-update-delete-project-time-update-delete';
import { apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain } from '../fn/project-time-updates/api-project-time-update-delete-project-time-update-delete-plain';
import { ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Params } from '../fn/project-time-updates/api-project-time-update-delete-project-time-update-delete-plain';
import { apiProjectTimeUpdateGetAllProjectTimeUpdatesPost } from '../fn/project-time-updates/api-project-time-update-get-all-project-time-updates-post';
import { ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Params } from '../fn/project-time-updates/api-project-time-update-get-all-project-time-updates-post';
import { apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain } from '../fn/project-time-updates/api-project-time-update-get-all-project-time-updates-post-plain';
import { ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Params } from '../fn/project-time-updates/api-project-time-update-get-all-project-time-updates-post-plain';
import { apiProjectTimeUpdateGetTimeUpdateGet } from '../fn/project-time-updates/api-project-time-update-get-time-update-get';
import { ApiProjectTimeUpdateGetTimeUpdateGet$Params } from '../fn/project-time-updates/api-project-time-update-get-time-update-get';
import { apiProjectTimeUpdateGetTimeUpdateGet$Plain } from '../fn/project-time-updates/api-project-time-update-get-time-update-get-plain';
import { ApiProjectTimeUpdateGetTimeUpdateGet$Plain$Params } from '../fn/project-time-updates/api-project-time-update-get-time-update-get-plain';
import { CreateProjectTimeUpdateCommandResult } from '../models/create-project-time-update-command-result';
import { DeleteProjectTimeUpdateCommandResult } from '../models/delete-project-time-update-command-result';
import { GetProjectTimesUpdateQueryResult } from '../models/get-project-times-update-query-result';
import { GetProjectTimeUpdateQueryResult } from '../models/get-project-time-update-query-result';

@Injectable({ providedIn: 'root' })
export class ProjectTimeUpdatesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectTimeUpdateGetAllProjectTimeUpdatesPost()` */
  static readonly ApiProjectTimeUpdateGetAllProjectTimeUpdatesPostPath = '/api/ProjectTimeUpdate/GetAllProjectTimeUpdates';

  /**
   * Get All Time Update for project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Response(params?: ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTimesUpdateQueryResult>> {
    return apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Time Update for project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain(params?: ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Params, context?: HttpContext): Observable<GetProjectTimesUpdateQueryResult> {
    return this.apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTimesUpdateQueryResult>): GetProjectTimesUpdateQueryResult => r.body)
    );
  }

  /**
   * Get All Time Update for project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateGetAllProjectTimeUpdatesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Response(params?: ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTimesUpdateQueryResult>> {
    return apiProjectTimeUpdateGetAllProjectTimeUpdatesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Time Update for project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateGetAllProjectTimeUpdatesPost(params?: ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Params, context?: HttpContext): Observable<GetProjectTimesUpdateQueryResult> {
    return this.apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTimesUpdateQueryResult>): GetProjectTimesUpdateQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTimeUpdateGetTimeUpdateGet()` */
  static readonly ApiProjectTimeUpdateGetTimeUpdateGetPath = '/api/ProjectTimeUpdate/GetTimeUpdate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateGetTimeUpdateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectTimeUpdateGetTimeUpdateGet$Plain$Response(params: ApiProjectTimeUpdateGetTimeUpdateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTimeUpdateQueryResult>> {
    return apiProjectTimeUpdateGetTimeUpdateGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateGetTimeUpdateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectTimeUpdateGetTimeUpdateGet$Plain(params: ApiProjectTimeUpdateGetTimeUpdateGet$Plain$Params, context?: HttpContext): Observable<GetProjectTimeUpdateQueryResult> {
    return this.apiProjectTimeUpdateGetTimeUpdateGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTimeUpdateQueryResult>): GetProjectTimeUpdateQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateGetTimeUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectTimeUpdateGetTimeUpdateGet$Response(params: ApiProjectTimeUpdateGetTimeUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTimeUpdateQueryResult>> {
    return apiProjectTimeUpdateGetTimeUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateGetTimeUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectTimeUpdateGetTimeUpdateGet(params: ApiProjectTimeUpdateGetTimeUpdateGet$Params, context?: HttpContext): Observable<GetProjectTimeUpdateQueryResult> {
    return this.apiProjectTimeUpdateGetTimeUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectTimeUpdateQueryResult>): GetProjectTimeUpdateQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTimeUpdateCreateProjectTimeUpdatePost()` */
  static readonly ApiProjectTimeUpdateCreateProjectTimeUpdatePostPath = '/api/ProjectTimeUpdate/CreateProjectTimeUpdate';

  /**
   * دا علشان تضيف وقت ع المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Response(params?: ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTimeUpdateCommandResult>> {
    return apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تضيف وقت ع المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain(params?: ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Params, context?: HttpContext): Observable<CreateProjectTimeUpdateCommandResult> {
    return this.apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTimeUpdateCommandResult>): CreateProjectTimeUpdateCommandResult => r.body)
    );
  }

  /**
   * دا علشان تضيف وقت ع المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateCreateProjectTimeUpdatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateCreateProjectTimeUpdatePost$Response(params?: ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTimeUpdateCommandResult>> {
    return apiProjectTimeUpdateCreateProjectTimeUpdatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تضيف وقت ع المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateCreateProjectTimeUpdatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateCreateProjectTimeUpdatePost(params?: ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Params, context?: HttpContext): Observable<CreateProjectTimeUpdateCommandResult> {
    return this.apiProjectTimeUpdateCreateProjectTimeUpdatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectTimeUpdateCommandResult>): CreateProjectTimeUpdateCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectTimeUpdateDeleteProjectTimeUpdateDelete()` */
  static readonly ApiProjectTimeUpdateDeleteProjectTimeUpdateDeletePath = '/api/ProjectTimeUpdate/DeleteProjectTimeUpdate';

  /**
   * دا علشان تمسح وقت من المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Response(params?: ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>> {
    return apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح وقت من المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain(params?: ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectTimeUpdateCommandResult> {
    return this.apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>): DeleteProjectTimeUpdateCommandResult => r.body)
    );
  }

  /**
   * دا علشان تمسح وقت من المشروع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectTimeUpdateDeleteProjectTimeUpdateDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Response(params?: ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>> {
    return apiProjectTimeUpdateDeleteProjectTimeUpdateDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح وقت من المشروع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectTimeUpdateDeleteProjectTimeUpdateDelete(params?: ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Params, context?: HttpContext): Observable<DeleteProjectTimeUpdateCommandResult> {
    return this.apiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>): DeleteProjectTimeUpdateCommandResult => r.body)
    );
  }

}
